let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f6Lrh")).then(() => parcelRequire('cOakm'));